export const buildAudioposobieTo = (listenLink) => {
    if (!listenLink?.grade) return '/audioposobie';
    return {
        pathname: '/audioposobie',
        state: {
            grade: listenLink.grade,
            disk_num: listenLink.disk_num ?? null,
        },
    };
};
